<template>
    <div class="emptyBox">
        <div class="box">
            <i class="icon icon_empty"></i>
            抱歉，没有找到相关结果!
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'empty',
    data() {
        return {}
    },
    created(){},
    methods: {},
    mounted() {}
  }
</script>

<style lang="scss" >
    .emptyBox{
        height:100%;
        .box{
            text-align: center;
            height:150px;
            line-height: 150px;
            font-size: 16px;
            color:#999;
            padding-top:150px;
            .icon_empty{
                display: inline-block;
                width:200px;
                height:150px;
                background: url('../../assets/no_icon.png') no-repeat;
                background-size: cover;
                margin-right:15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/productInfoComponents/empty.vue